import { useEffect, useState } from "react";
import ENDPOINTS from "../api/endPoint";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(() => {
    return typeof navigator !== "undefined" ? navigator.onLine : true;
  });
  const [wasOffline, setWasOffline] = useState(false);
  const [serverStatus, setServerStatus] = useState({
    loading: true,
    online: false,
    ping: 0,
    maintenance: false,
    lastChecked: null,
  });

  const checkNetworkStatus = async () => {
    try {
      const online = navigator.onLine;
      setIsOnline(online);
      return online;
    } catch {
      setIsOnline(false);
      return false;
    }
  };

  const checkServerStatus = async () => {
    const startTime = Date.now();
    try {
      const response = await fetch(
        `${API_BASE_URL}${ENDPOINTS.HEALTH}`,
        {
          method: "GET",
          cache: "no-store",
        }
      );

      const data = await response.json();
      const ping = Date.now() - startTime;

      setServerStatus({
        loading: false,
        online: response.ok,
        ping,
        maintenance: data?.maintenance || false,
        lastChecked: new Date(),
      });

      return response.ok;
    } catch (error) {
      setServerStatus((prev) => ({
        ...prev,
        loading: false,
        online: false,
        lastChecked: new Date(),
      }));
      return false;
    }
  };

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setWasOffline(true);
      checkServerStatus();
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Initial checks
    checkNetworkStatus();
    checkServerStatus();

    // Periodic checks
    const networkInterval = setInterval(checkNetworkStatus, 30000);
    const serverInterval = setInterval(checkServerStatus, 60000);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(networkInterval);
      clearInterval(serverInterval);
    };
  }, []);

  return {
    isOnline,
    wasOffline,
    serverStatus,
    refreshServerStatus: checkServerStatus,
  };
}
